import React from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import { ContactableStatus, PtpStatus, PtpStatusLabel, RecommendedCaseDetails } from '../types';
import { FeedbackTypesCodeMap } from '../../Cases/constants/CasesConstants';
import cx from 'classnames';
import { isToday } from '@cp/src/utils/DateHelper';
import { CaseItemProps } from '../types';

const CaseItem: React.FC<CaseItemProps> = ({ caseItem, index, totalItems }) => {
  const isContactedToday = isToday(
    caseItem.attributes.latestInteractionTimestamp?.toString() || ''
  );

  return (
    <div
      key={`${caseItem.caseReferenceId}-${index}`}
      className={`grid grid-cols-[1fr_2fr] gap-4 px-6 py-4 border-b border-[var(--grayscale-4)] last:border-b-0 ${
        index % 2 === 1 ? 'bg-[var(--grayscale-6)]' : ''
      } ${index === totalItems - 1 ? 'mb-4' : ''}`}
    >
      <div className="flex items-center">
        <Typography
          variant="p3"
          color={caseItem.isVisited ? 'var(--grayscale-cold-4)' : 'var(--grayscale-2)'}
        >
          {caseItem.attributes.customerName}
        </Typography>
      </div>
      <div className={cx('flex items-center', index === totalItems - 1 ? 'mb-3' : '')}>
        <Typography
          variant="p4"
          color={caseItem.isVisited ? 'var(--grayscale-cold-4)' : 'var(--grayscale-2)'}
        >
          Has{' '}
          <strong>
            {caseItem.attributes.ptpState
              ? PtpStatusLabel[caseItem.attributes.ptpState as keyof typeof PtpStatus] ||
                caseItem.attributes.ptpState
              : 'no PTP'}
          </strong>{' '}
          and last feedback was{' '}
          <strong>
            {caseItem.attributes.latestDisposition
              ? FeedbackTypesCodeMap[caseItem.attributes.latestDisposition]?.label ||
                caseItem.attributes.latestDisposition
              : 'no feedback'}
          </strong>{' '}
          and is{' '}
          {isContactedToday
            ? ContactableStatus.ATTEMPTED_TODAY
            : ContactableStatus.NOT_ATTEMPTED_TODAY}
        </Typography>
      </div>
    </div>
  );
};

export default CaseItem;
